var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "q-modal",
    {
      staticClass: "sl-modal",
      attrs: {
        id: "addressValidationModal",
        value: _vm.addressValidationModal
      },
      on: {
        hide: function($event) {
          _vm.closeModal("addressValidation")
        }
      }
    },
    [
      _c(
        "q-modal-layout",
        [
          _c(
            "q-toolbar",
            { attrs: { slot: "header" }, slot: "header" },
            [
              _c(
                "q-toolbar-title",
                [
                  _c("q-icon", { attrs: { name: "fa fa-map-marker" } }),
                  _vm._v("Address Validation Report\n      ")
                ],
                1
              ),
              _c("q-icon", {
                attrs: { name: "clear" },
                nativeOn: {
                  click: function($event) {
                    _vm.closeModal("addressValidation")
                  }
                }
              })
            ],
            1
          ),
          _c("div", { staticStyle: { padding: "40px 20px" } }, [
            _c("div", { staticClass: "sl-row" }, [
              _c("div", { staticClass: "sl-col-12" }, [
                _c(
                  "p",
                  {
                    staticClass: "text-center",
                    staticStyle: { "max-width": "420px", margin: "0 auto" }
                  },
                  [
                    _vm._v(
                      "\n            How the student addresses stand with Google for classes "
                    ),
                    _c("b", [_vm._v("starting")]),
                    _vm._v(" within the date range.\n          ")
                  ]
                )
              ])
            ]),
            _c("div", { staticClass: "sl-row", staticStyle: { margin: "0" } }, [
              _c(
                "div",
                { staticClass: "sl-col-6" },
                [
                  _c("q-datetime", {
                    attrs: { "stack-label": "Start Date *" },
                    model: {
                      value: _vm.startDate,
                      callback: function($$v) {
                        _vm.startDate = $$v
                      },
                      expression: "startDate"
                    }
                  })
                ],
                1
              ),
              _c(
                "div",
                { staticClass: "sl-col-6" },
                [
                  _c("q-datetime", {
                    attrs: { "stack-label": "End Date *" },
                    model: {
                      value: _vm.endDate,
                      callback: function($$v) {
                        _vm.endDate = $$v
                      },
                      expression: "endDate"
                    }
                  })
                ],
                1
              )
            ]),
            _vm.result
              ? _c(
                  "div",
                  { staticClass: "address-validation-summary" },
                  [
                    _c("div", { staticClass: "totals" }, [
                      _c("div", [
                        _c("b", [_vm._v(_vm._s(_vm.result.summary.students))]),
                        _vm._v(" students in "),
                        _c("b", [_vm._v(_vm._s(_vm.result.summary.classes))]),
                        _vm._v(" classes")
                      ]),
                      _c("div", [
                        _c("b", [
                          _vm._v(_vm._s(_vm.result.summary.classesAffected))
                        ]),
                        _vm._v(
                          "\n            " +
                            _vm._s(
                              _vm.result.summary.classesAffected === 1
                                ? "class has"
                                : "classes have"
                            ) +
                            "\n            an address that is not validated or has a fix available\n          "
                        )
                      ])
                    ]),
                    _vm._l(_vm.categories, function(category) {
                      return _c(
                        "div",
                        {
                          key: category.key,
                          staticClass: "category",
                          attrs: { title: category.hint }
                        },
                        [
                          _c("span", { class: "text-" + category.color }, [
                            _vm._v(_vm._s(category.label))
                          ]),
                          _c("b", [
                            _vm._v(_vm._s(_vm.result.summary[category.key]))
                          ])
                        ]
                      )
                    })
                  ],
                  2
                )
              : _vm._e()
          ]),
          _c(
            "q-toolbar",
            { attrs: { slot: "footer" }, slot: "footer" },
            [
              _c("q-toolbar-title"),
              _c("q-btn", {
                attrs: {
                  color: "green",
                  icon: "fa fa-play",
                  label: "Run",
                  loading: _vm.running
                },
                nativeOn: {
                  click: function($event) {
                    _vm.runReport()
                  }
                }
              }),
              _vm._v(" \n      "),
              _vm.result
                ? _c("q-btn", {
                    attrs: {
                      color: "primary",
                      outline: "",
                      icon: "fa fa-download",
                      label: "Download"
                    },
                    nativeOn: {
                      click: function($event) {
                        _vm.download()
                      }
                    }
                  })
                : _vm._e(),
              _vm._v(" \n      "),
              _c("q-btn", {
                attrs: { outline: "", color: "faded", label: "Cancel" },
                nativeOn: {
                  click: function($event) {
                    _vm.closeModal("addressValidation")
                  }
                }
              })
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }